import { queryOptions, UseQueryOptions } from "@tanstack/react-query";
import { Build, Job } from "~/components/build/Show/lib/types";
import fetcher from "~/components/build/Show/lib/fetcher";

export const jobArtifactsCountQueryKey = (buildId: Build["id"], jobId: Job["id"]) => {
  return ["build", buildId, "jobs", jobId, "artifacts-count"];
};

export const jobArtifactsCountQueryOptions = (
  buildId: Build["id"],
  jobId: Job["id"],
  jobBasePath: string,
  queryOptionsArgs: Omit<UseQueryOptions<number>, "queryKey" | "queryFn"> = {},
) => {
  return queryOptions({
    queryKey: jobArtifactsCountQueryKey(buildId, jobId),
    queryFn: ({ signal }) => fetchJobArtifactsCount(jobBasePath, signal),
    ...queryOptionsArgs,
  });
};

function fetchJobArtifactsCount(jobBasePath: string, signal: AbortSignal): Promise<number> {
  const url = new URL(`${jobBasePath}/artifacts/count`, window.location.origin);

  return fetcher<number>(url, true, { signal });
}
